import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/mobile_sign';

export default function MobileSign() {
  return (
    <>
      <PageTemplate type={true}>
        <Container />
      </PageTemplate>
    </>
  );
}
